export default interface platformMajAnimationLogoDto {
  id?: string;
  length: number;
  distance: number;
  fileFormat: string;
  // backColor: string;
  withDescription: boolean;
  descriptionType: descriptionType;
  descriptions: platformMajDescriptionDto[];
}

export interface platformMajDescriptionDto {
  start: number;
  description: any;
  onScroll?: boolean;
}

export enum descriptionType {
  step = 1,
  appear = 2,
}

export const homeGhajari3TopTemplate: platformMajAnimationLogoDto =
{
  id: "homeTop",
  length: 15,
  distance: 100,
  fileFormat: '.png',
  withDescription: true,
  descriptionType: 1,
  descriptions: [
    
    { start: 0, description: "<h2>Skills</h2>" },
    { start: 200, description: `<p><b>Front-end Development: </b>React JS, Redux, Material-UI, HTML, CSS, Sass, JavaScript (ES5/ES6), TypeScript, Single-Page Applications , Responsive Web Design</p>` },
    { start: 400, description: `<p><b>Back-end Development: </b>ASP.NET Core, C#, RESTful APIs, Domain-Driven Design, Object-Oriented Programming, Design Patterns</p>` },
    { start: 600, description: `<p><b>Databases: </b>Microsoft SQL Server, Elasticsearch (NoSQL)</p>` },
    { start: 800, description: `<p><b>Tools & Platforms: </b>Git, Visual Studio, Azure, Agile/Scrum</p>` },
    { start: 1000, description: `<p><b>Other Skills: </b>T-SQL, Unit Testing, CI/CD Pipelines</p>` },
    { start: 1200, description: `<p><b>Soft Skills: </b>Problem-solving, teamwork, adaptability, communication, time management, attention to detail, and critical thinking</p>` },
  ]
};